import { routes } from 'routes/routes';
import type { GenerateCommentPathProperties } from './types';

export const generateCommentContentObjectPath = ({ id, type }: { id: string; type: string }) => {
  switch (type) {
    case 'activity':
      return routes.contentObjects.activities(id);
    case 'event':
      return routes.contentObjects.events(id);
    case 'kudo':
      return routes.contentObjects.kudos(id);
    case 'poll':
      return routes.contentObjects.polls(id);
    case 'post':
      return routes.contentObjects.posts(id);
    case 'withings_order_post':
      return routes.contentObjects.withingsOrderPosts(id);
    default:
      throw new Error(`Not implemented yet: ${type} case`);
  }
};

export const generateCommentPath = ({
  comment,
  parentId,
  topParentShareableId,
  topParentType,
}: GenerateCommentPathProperties) => {
  const contentObjectPath = generateCommentContentObjectPath({
    id: topParentShareableId,
    type: topParentType,
  });

  const commentPath = parentId === comment.id ? comment.id : `${comment.parentId}/${comment.id}`;
  return `${contentObjectPath}/comments/${commentPath}`;
};
